export const remarcarCoincidencias = (textoOriginal: string, busqueda: string) => {
    let resultado = textoOriginal;
    const creterioBusqueda = busqueda.trim();
    if (creterioBusqueda.split(' ').length === 1) {
        resultado = resultado.replace(new RegExp(creterioBusqueda, 'gi'), (str: string) => `<b style="background-color: #FCFA51">${str}</b>`);
    } else {
        creterioBusqueda.split(' ').forEach((el: any) => {
            resultado = resultado.replace(new RegExp(el, 'gi'), (str: string) => `<b style="background-color: #FCFA51">${str}</b>`);
        });
    }
    return resultado;
};